import React from "react";

function HighLightRowWrapper({
  children,
  selected = false,
  baseClass = "border-b",
  selectedClass = "bg-yellow-200",
  unselectedClass = "hover:bg-gray-100",
  onClick,
  domId,
}) {
  return (
    <tr
      className={`${baseClass} ${selected ? selectedClass : unselectedClass} ${
        onClick ? "cursor-pointer" : ""
      }`}
      id={domId}
      onClick={(e) => {
        // Avoid triggering onClick when clicking on interactive elements ex. input(checkbox), button etc.
        if (onClick && ["TD", "DIV"].indexOf(e.target.tagName) > -1) {
          onClick();
        }
      }}
    >
      {children}
    </tr>
  );
}

export default HighLightRowWrapper;
